import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type { User, UserVo, UserInfo } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
import type { UserListParam } from "@/entity/user";
import type { Page } from "@zhihaoscm/entity";
export class UserService extends BaseService<User, UserVo, UserListParam, any> {
    public async get(id: number | string): Promise<any> {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }
    // 根据权限查询
    public async getPermission(permission: string, name: string): Promise<User[]> {
        const { data } = await this.service.get(`${this.path}/permission?permission=${permission}&name=${name}`);
        return data;
    }

    @confirmable("是否删除，删除后用户重新登录将重新注册账号")
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }
    /**账号管理下拉列表 */
    public async userSelector(name?: string): Promise<Array<UserInfo>> {
        const { data } = await this.service.get(`${this.path}/selector?name=${name}`);
        return data;
    }
    /**账号管理下拉列表根据用户名和状态 */
    public async userSelectorByState(params: { name?: string; state: number }): Promise<Array<UserInfo>> {
        const { data } = await this.service.get(`${this.path}/selectorUser`, { params });
        return data;
    }
    /**账号管理下拉列表（企业定制） */
    public async userSelectorEnterprise(name?: string): Promise<Array<UserInfo>> {
        const { data } = await this.service.get(`${this.path}/selector?name=${name}&origin=1`);
        return data;
    }
    /**
     * 后端迁移接口文档失效，等接口文档出结果后再添加
     */
    public async getUserFollowPaging(params: UserListParam): Promise<Page<UserVo>> {
        const { data } = await this.service.get(`${this.path}/follow/paging`, { params });
        return data;
    }
    /**
     * 围栏提醒-分页查询
     * @param {number} page 页码
     * @param {number} size 每页条数
     * @param {string} keywords 姓名/手机号
     * @param {string} roleKeywords 角色名称
     * @returns
     */
    public async pagingReminder(page: number, size: number, keywords: string, roleKeywords: string): Promise<any> {
        const { data } = await this.service.get(`${this.path}/reminder/paging`, {
            params: {
                page,
                size,
                keywords,
                roleKeywords
            }
        });
        return data;
    }
}

export const userService = new UserService("/admin/user", request.service);
